import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api, coverUri } from "../lib/api";
import { initials } from "../lib/format";
import { Spinner, EmptyState } from "../components/ui";
import { Icon } from "../components/icons";

function RoomRow({ room, onClick }) {
  const avatar = coverUri(room.avatar);
  return (
    <button onClick={onClick} data-testid={`chat-room-${room.room}`} className="card" style={{ display: "flex", alignItems: "center", gap: 12, padding: 12, cursor: "pointer", color: "inherit", width: "100%", textAlign: "left" }}>
      <div className="avatar" style={{ width: 46, height: 46, fontSize: 16, background: room.type === "comunicados" ? "var(--brand-tertiary)" : "var(--surface-3)" }}>
        {avatar ? <img src={avatar} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : room.type === "comunicados" ? <Icon name="megaphone" size={20} color="var(--brand-primary)" /> : initials(room.title || room.room)}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontFamily: "var(--f-medium)", fontSize: 15, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{room.title || room.room}</div>
        <div style={{ color: "var(--on-surface-3)", fontSize: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {room.last_message ? `${room.last_message.user_name ? room.last_message.user_name + ": " : ""}${room.last_message.text || room.last_message.filename || "Anexo"}` : room.members ? `${room.members} membros` : "Sem mensagens"}
        </div>
      </div>
      {room.unread ? <span className="pill" style={{ background: "var(--brand-primary)", color: "var(--on-brand)", minWidth: 22, textAlign: "center" }}>{room.unread}</span> : <Icon name="chevron-forward" size={18} color="var(--muted)" />}
    </button>
  );
}

export default function Naipe() {
  const navigate = useNavigate();
  const q = useQuery({ queryKey: ["chat-rooms"], queryFn: () => api("/chat/rooms") });
  const rooms = q.data || [];
  const naipes = rooms.filter((r) => r.type !== "comunicados");
  const comms = rooms.filter((r) => r.type === "comunicados");

  return (
    <>
      <div className="page-header">
        <h1 className="t-h1">Naipe</h1>
      </div>
      {q.isLoading ? (
        <Spinner />
      ) : (
        <div className="page ulc-fade" style={{ maxWidth: 720 }}>
          {!rooms.length ? <EmptyState icon="chatbubbles-outline" text="Sem conversas disponíveis." /> : null}
          {comms.length ? (
            <>
              <div className="t-section" style={{ marginBottom: 10 }}>Comunicações</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 24 }}>
                {comms.map((r) => <RoomRow key={r.room} room={r} onClick={() => navigate(`/chat/${encodeURIComponent(r.room)}`)} />)}
              </div>
            </>
          ) : null}
          {naipes.length ? (
            <>
              <div className="t-section" style={{ marginBottom: 10 }}>Chats de naipe</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {naipes.map((r) => <RoomRow key={r.room} room={r} onClick={() => navigate(`/chat/${encodeURIComponent(r.room)}`)} />)}
              </div>
            </>
          ) : null}
        </div>
      )}
    </>
  );
}
